import { render, staticRenderFns } from "./SpotTheNot.vue?vue&type=template&id=3b3ed848&scoped=true"
import script from "./SpotTheNot.vue?vue&type=script&lang=js"
export * from "./SpotTheNot.vue?vue&type=script&lang=js"
import style0 from "./SpotTheNot.vue?vue&type=style&index=0&id=3b3ed848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ed848",
  null
  
)

export default component.exports